  <div class="widget-content">

    <div class="filter-toolbar">

      <div class="filter-toolbar-item">
        <input class="search-bar form-control" placeholder="Search..." [(ngModel)]="searchText" pInputText type="text" (input)="applyFilter()">
      </div>

      <div class="filter-toolbar-item controls">
        <label for="filterIncludeStandard">Standard</label>
        <p-checkbox id="filterIncludeStandard" [(ngModel)]="filterIncludeStandard" binary="true" (onChange)="applyFilter()"></p-checkbox>

        <label for="filterIncludeCustom">Custom</label>
        <p-checkbox id="filterIncludeCustom" [(ngModel)]="filterIncludeCustom" binary="true" (onChange)="applyFilter()"></p-checkbox>
      </div>

    </div>


    <div class="data-table table-container larger-font">
      <p-table #dt [value]="profiles"
                   selectionMode="single"
                   [paginator]="false"
                   [rows]="10"
                   [pageLinks]="10"
                   [loading]="loading" loadingIcon="fa fa-spinner"
                   responsiveLayout="scroll">
        <ng-template pTemplate="header">
          <tr>
            <th [pSortableColumn]="'name'">Name
              <p-sortIcon [field]="'name'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'type'">Profile
              <p-sortIcon [field]="'type'"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-profile>
          <tr (click)="onRowSelect(row)" class="ui-selectable-row">
            <td>{{profile.name}}</td>
            <td>{{profile.type}}</td>
          </tr>
        </ng-template>
      </p-table>
      <mojo-table-paginator [table]="dt"></mojo-table-paginator>
    </div>
  </div>
